export default __webpack_public_path__ + "static/ViceCitySans-1a1b22416add66ac64b75052dfdc5e47.woff2";